.commentText {
    color: var(--hps-blue);
    white-space: pre-wrap;
}
